import type { HTMLAttributes, ReactNode } from 'react';

/** Cartão (C-12). Com `title`, ganha cabeçalho com ações à direita. */
export default function Card({ title, actions, children, flat, soft, className = '', ...rest }: HTMLAttributes<HTMLDivElement> & {
  title?: ReactNode;
  actions?: ReactNode;
  flat?: boolean;
  soft?: boolean;
}) {
  if (title !== undefined || actions) {
    return (
      <section className={`card flat ${className}`} {...rest}>
        <header className="card-head">
          {typeof title === 'string' ? <h2>{title}</h2> : title}
          {actions && <div className="row">{actions}</div>}
        </header>
        <div className="card-body">{children}</div>
      </section>
    );
  }
  return <div className={`card ${flat ? 'flat' : ''} ${soft ? 'soft' : ''} ${className}`} {...rest}>{children}</div>;
}
